<template>
  <AuthHeader
    :title="t('Добро пожаловать!')"
    :subtitle="
      t(
        'Войдите в свой аккаунт или зарегистрируйтесь, чтобы получить полный доступ.',
      )
    "
  />
  <div class="home-page-actions">
    <BaseButton
      variant="dark"
      with-full
      with-decor
      data-testid="open-signin-btn"
      @click="navigateTo(permissions.AUTH.SIGNIN.ROUTE)"
    >
      {{ t("Войти") }}
    </BaseButton>
    <BaseButton
      variant="primary"
      with-full
      with-decor
      data-testid="open-signout-btn"
      @click="navigateTo(permissions.AUTH.SIGNUP.ROUTE)"
    >
      {{ t("Зарегистрироваться") }}
    </BaseButton>
    <AuthContactDevelopersBlock />
  </div>
</template>

<script setup lang="ts">
// lib
import { useI18n } from 'vue-i18n'

// app
import { AuthContactDevelopersBlock, AuthHeader } from '~/entities/auth'
import { permissions } from '~/shared/lib'
import { BaseButton } from '~/shared/ui'
import i18n from '../model/HomePage.i18n.json'

const { t } = useI18n(i18n)
</script>

<style scoped lang="scss">
.home-page-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: rem(12px);

  a {
    font-weight: 700;
  }
}
</style>
